import style from './InputName.module.scss';
const InputName = ({
  errors,
  errorLabel,
  testid,
  placeholder,
  label,
  inputClassName,
  labelClassName,
  page,
  ...field
}) => {
  return <>
      <input {...field} ref={field.ref} data-testid={testid} className={page === 'visual' ? inputClassName : style.inputName} type='text' placeholder={placeholder} data-has-error={errors ? 'true' : 'false'} />
      <label className={page === 'visual' ? labelClassName : style.inputLabel}>{label}</label>
      <div className={style.inputError}>{errors && errorLabel}</div>
    </>;
};
export default InputName;